module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/containers/PlayersMatchingView/images/resetSelectedVehiclesButton.c550d136.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/containers/PlayersMatchingView/images/resetSelectedVehiclesButton.png
// module id = 2798
// module chunks = 11